// Renders a single accordion section.
import React, { Fragment } from "react";
import styles from "../Accordion.module.scss";

const useStylesAnimations = (section) => {
  return {
    expanded_icon: section.isExpanded ? styles.minus_icon : styles.plus_icon,
    isCompleted: section.isComplete && styles.completed,
    isExpanded: section.isExpanded === true ? styles.active + " " + styles.subsection.active : "",
    active: section.isSelected ? styles.active: ""
  };
};

const selection = (onSelected) => (s) => {
  const animations = useStylesAnimations(s);

  return (
    <Fragment key={s.id}>
      <div
        onClick={() => onSelected(s, 2)}
        key={s.id}
        className={`${styles.subsection} ${animations.active}`}
      >
        <span className={`${styles.expanded_icon} ${animations.expanded_icon}`} />
        <span className={`${styles.caption}`}>{s.caption}</span>
        <span className={`${animations.isCompleted}`}/>

      </div>
      <div className={`${styles.content_panel} ${animations.isExpanded}`}>
        {s.sections && s.sections.map(innerSelection(onSelected))}
      </div>
    </Fragment>
  );
};

const innerSelection = (onSelected) => (s) => {
  const animations = useStylesAnimations(s);
  return (
      <div
        onClick={() => onSelected(s, 3)}
        key={s.id}
        className={`${styles.subsection} ${animations.active}`}
      >
        <span className={`${styles.caption}`}>{s.caption}</span>
        <span
          className={`${animations.isCompleted}`}
        />
      </div>
  );
};

function AccordionSection({ dispatch, section, onSelected }) {
  const animations = useStylesAnimations(section);
  return (
    <Fragment key={section.id}>
      <button
        className={`${styles.collapsible_caption} ${animations.active}`}
        // ellipsis
        onClick={() => onSelected(section, 1)}
      >
        <span
          className={`${styles.expanded_icon} ${animations.expanded_icon}`}
        />
        <span className={`${styles.caption}`}>{section.caption}</span>
        <span className={`${animations.isCompleted}`}/>
      </button>

      <div className={`${styles.content_panel} ${animations.isExpanded}`}>
        {section.sections && section.sections.map(selection(onSelected))}
      </div>
    </Fragment>
  );
}
export default AccordionSection;
